/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Table_KeyInputs */

const en_options_api_keys_table_key = /** @type {(inputs: Options_Api_Keys_Table_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key`)
};

const fr_options_api_keys_table_key = /** @type {(inputs: Options_Api_Keys_Table_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clé`)
};

const de_options_api_keys_table_key = /** @type {(inputs: Options_Api_Keys_Table_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel`)
};

const it_options_api_keys_table_key = /** @type {(inputs: Options_Api_Keys_Table_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiave`)
};

const ru_options_api_keys_table_key = /** @type {(inputs: Options_Api_Keys_Table_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключ`)
};

const es_options_api_keys_table_key = /** @type {(inputs: Options_Api_Keys_Table_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llave`)
};

const zh_cn2_options_api_keys_table_key = /** @type {(inputs: Options_Api_Keys_Table_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`钥匙`)
};

const ja_options_api_keys_table_key = /** @type {(inputs: Options_Api_Keys_Table_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鍵`)
};

const hi_options_api_keys_table_key = /** @type {(inputs: Options_Api_Keys_Table_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चाबी`)
};

const pt_pt2_options_api_keys_table_key = /** @type {(inputs: Options_Api_Keys_Table_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave`)
};

/**
* | output |
* | --- |
* | "Key" |
*
* @param {Options_Api_Keys_Table_KeyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_table_key = /** @type {((inputs?: Options_Api_Keys_Table_KeyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Table_KeyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_table_key(inputs)
	if (locale === "de") return de_options_api_keys_table_key(inputs)
	if (locale === "it") return it_options_api_keys_table_key(inputs)
	if (locale === "ru") return ru_options_api_keys_table_key(inputs)
	if (locale === "es") return es_options_api_keys_table_key(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_table_key(inputs)
	if (locale === "ja") return ja_options_api_keys_table_key(inputs)
	if (locale === "hi") return hi_options_api_keys_table_key(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_table_key(inputs)
	return en_options_api_keys_table_key(inputs)
});